import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

/**
 * Generic read of the lines of a fee settlement run (bm.BmFeeSettlementLine). Read only: the lines are
 * written by the calculation of the run, the backend refuses generic writes.
 */
@Injectable({
    providedIn: 'root'
})
export class BmFeeSettlementLineService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bm/feeSettlementLines')
    }
}
